var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.accordionClass},[_c('p',{class:_vm.classObject,on:{"click":_vm.handleAccordion}},[_vm._v(" "+_vm._s(_vm.accordionHeader)+" ")]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpen),expression:"isOpen"}],class:_vm.accordionClass + '-content'},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }